import {createContext} from "react";

const simplyContext = createContext({
    state: {},
    fResetNavigate: () => {},
    fNavigate: () => {},
    fPreloader: () => {},
    fOffConvas: () => {},
    fReset: () => {},
    fOffConvas2: () => {},
    fHome: () => {},
    fNotPermission: () => {},
    fPage: () => {},
    fNews: () => {},
    fDropDown: () => {},
    fNewsMarjaiat: () => {},
    fGozareshTasviriAll: () => {},
    fGozareshTasviri: () => {},
    fSearch: () => {},
    fOffConvas3: () => {},
    fSearchInput: () => {},
    fKotobMrjaiatElmi: () => {},
    fMahsoolatJadid: () => {},
    fHekmatBonyan: () => {},
    fNoavar: () => {},
    fPezeshkKhanevade: () => {},
    fHeyatElmi: () => {},
    fSazVaKar: () => {},
    fSarFasl: () => {},
    fLogout: () => {},
    fSetLoggedIn: () => {},
    fEghtesadModiriat: () => {},
    fSalamat: () => {},
    fBimarestan: () => {},
    fRotebaBandi: () => {},
    fNokhbegan: () => {},
    fCorona: () => {},
    fMahsoolatSiasati: () => {},
    fAmoozeshSalamat: () => {},
    })


export default simplyContext